<template>
  <div class="view-container">
    <form id="cancel" class="payment-result-form">
        <h1>Cancelled</h1>
        <span>Your payment has been cancelled.</span>
        <br /><br />
        <a class="btn btn-primary" href="/menu">Continue Ordering</a>
    </form>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "Cancel",
  components: {
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  }
};
</script>
